<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    :class="rounded ? 'button-rounded' : 'button'"
    :style="{ backgroundColor }"
  >
    <slot />
  </button>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    backgroundColor: {
      type: String,
      default: '#EE7600',
    },
    rounded: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
<style scoped>
.button {
  align-items: center;
  height: 30px;
  padding: 0 16px;
  border: none;
  border-radius: 6px;
  text-align: center;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s;
  color: #fff;
}
.button:hover, .button-rounded:hover {
  cursor: pointer;
  -webkit-transform: scale(1.02);
  transform: translate(0, -2px);
  box-shadow: 0 7px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.button-rounded {
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  width: 45px;
  border: none;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s linear;
  color: #fff;
}
.button:active {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}
.button:focus {
  outline: 0;
}
.button:disabled {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}
</style>

